import { render } from "./cascader.vue?vue&type=template&id=67a88a53"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__